import { ToolSchema, ToolImplementation, ToolResult } from '../tool-types';
import {
  getProvinzialNextStateIds,
  setCurrentProvinzialStateId,
  type ProvinzialConversationStateId
} from '@/config/provinzial-conversation-states';
import { getProvinzialRealtimeInstructions } from '@/config/provinzial-instructions';
import { toolRegistry } from '@/tools/tool-registry';

const ALL_STATE_IDS: ProvinzialConversationStateId[] = [
  'greeting',
  'identify_scenario',
  'gather_vehicle_basic',
  'gather_fin',
  'gather_coverage_info',
  'confirm_and_issue',
  'next_steps',
  'close'
];

export const stateChangeToolProvinzialSchema: ToolSchema = {
  type: 'function',
  name: 'set_conversation_state',
  description:
    'Switch the customer service conversation to the next state. Only call this when the exit condition is met.',
  parameters: {
    type: 'object',
    properties: {
      next_state: {
        type: 'string',
        enum: ALL_STATE_IDS,
        description: 'Next conversation state id'
      }
    },
    required: ['next_state'],
    additionalProperties: false
  }
};

export const stateChangeToolProvinzialImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  const { next_state: nextState } = args ?? {};

  if (!nextState || !ALL_STATE_IDS.includes(nextState)) {
    return { success: false, error: 'Invalid next_state provided.' };
  }

  setCurrentProvinzialStateId(nextState);
  const allowedNext = getProvinzialNextStateIds(nextState).join(', ') || 'none';

  return {
    success: true,
    data: `State updated to ${nextState}. Allowed next states: ${allowedNext}.`,
    sessionUpdate: {
      instructions: getProvinzialRealtimeInstructions(nextState),
      tools: toolRegistry.getToolSchemas()
    }
  };
};
